import { render, staticRenderFns } from "./BulkInsertUpdateSessionList.vue?vue&type=template&id=0d283fb8&scoped=true&"
import script from "./BulkInsertUpdateSessionList.vue?vue&type=script&lang=js&"
export * from "./BulkInsertUpdateSessionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d283fb8",
  null
  
)

export default component.exports